/**
 * TruePrice V1 - Medium Types
 * 
 * Defines the supported painting mediums and their properties.
 * Source: SSOT Addendum C (Medium Selector), Addendum D (PSI Constants)
 */

export const MEDIUM_KEYS = ['oil', 'acrylic', 'watercolor', 'gouache', 'pastel', 'mixed_media'] as const;

export type MediumKey = typeof MEDIUM_KEYS[number];

export interface MediumConfig {
  key: MediumKey;
  label: string;
  description: string;
  isPaperBased: boolean; // Affects density relaxer (Addendum E)
}

export const MEDIUMS: Record<MediumKey, MediumConfig> = {
  oil: {
    key: 'oil',
    label: 'Oil',
    description: 'Oil paint on canvas or panel',
    isPaperBased: false,
  },
  acrylic: {
    key: 'acrylic',
    label: 'Acrylic',
    description: 'Acrylic paint on canvas or panel',
    isPaperBased: false,
  },
  watercolor: {
    key: 'watercolor',
    label: 'Watercolor',
    description: 'Watercolor on paper',
    isPaperBased: true,
  },
  gouache: {
    key: 'gouache',
    label: 'Gouache',
    description: 'Gouache on paper or board',
    isPaperBased: true,
  },
  pastel: {
    key: 'pastel',
    label: 'Pastel',
    description: 'Soft or oil pastel on paper',
    isPaperBased: true,
  },
  mixed_media: {
    key: 'mixed_media',
    label: 'Mixed Media',
    description: 'Multiple mediums combined',
    isPaperBased: false,
  },
};

export function isMediumKey(value: string): value is MediumKey {
  return MEDIUM_KEYS.includes(value as MediumKey);
}

export function getMediumConfig(key: MediumKey): MediumConfig {
  return MEDIUMS[key];
}
